import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const PercentageMeter = function (options) {
    const container = $(options.container);
    const graphText = options.graphText ? options.graphText: 'Avg. Progress';

    Thinker.begin($(options.container));
    Api.send(options.url, {guideid: container.data('id')}).done(function (response) {
        Thinker.end($(options.container));
        const width = 240;
        const stat = response.stat ? response.stat : response;

        const twoPi = 2 * Math.PI;
        let progress = 0,
            avg = stat / 100,
            formatPercent = d3.format(".0%");

        const arc = d3.arc()
            .startAngle(0)
            .innerRadius(75)
            .outerRadius(110);

        const percentChart = d3.select(options.svg)
            .attr('width', width)
            .attr('height', width)
            .append('g')
            .attr('transform', 'translate(' + width / 2 + ',' + width / 2 + ')');

        const meter = percentChart.append('g')
            .attr('class', 'percentage-meter');

        meter.append('path')
            .attr('class', 'background')
            .attr('d', arc.endAngle(twoPi));

        const foreground = meter.append('path')
            .attr('class', 'foreground');

        const percentComplete = meter.append('text')
            .attr('text-anchor', 'middle')
            .attr('class', 'percent-complete')
            .attr('dy', '0em');

        meter.append('text')
            .attr('text-anchor', 'middle')
            .attr('class', 'description')
            .attr('dy', '2.3em')
            .text(graphText);


        d3.transition(options.svg).duration(1000).tween('progress', function () {
            const i = d3.interpolateNumber(progress, avg);
            return function (t) {
                foreground.attr("d", arc.endAngle(twoPi * i(t)));
                percentComplete.text(formatPercent(i(t)));
            };
        });

        container.find('span').prepend(options.message(Math.round(stat)));
        //`<strong>Users progress ${Math.floor(stat)}% through the guide on average before stopping.</strong>`
    });


};

export default PercentageMeter;
